// eslint-disable-next-line import/no-cycle
import AuthService from "../../service";

const membershipRate = {
  getMembershipRate(page,search,sort_order) {
    return AuthService.get(`/membership/membership_rates?`+
      `page=${page}` +
      `&sort_order=${sort_order}` +
      `&search=${search}`
    );
  },
  showMembershipRate(id) {
    return AuthService.get(`/membership/membership_rates/${id}`);
  },
  createMembershipRate(data) {
    return AuthService.post("/membership/membership_rates", data);
  },
  updateMembershipRate(id, data) {
    return AuthService.put(`/membership/membership_rates/${id}`, data);
  },
  deleteMembershipRate(id) {
    return AuthService.delete(`/membership/membership_rates/${id}`);
  }
};
export default membershipRate;
